<template>
  <sc-panel-navigator>
    <el-card
    >
      <el-row slot="header">
        <span class="menu-title">P.P Manager</span>

        <sf-button
            style="float: right"
            material="add"
            size="large"
            type="primary"
            @click="$refs.pups.appendRecord()"
        ></sf-button>
        <sf-button
            plain
            type="success"
            style="float:right"
            @click="importDialog=!importDialog">
          <fa
              icon="file-upload"
              fixed-width
              size="lg"></fa>
        </sf-button>
      </el-row>
      <el-row style="padding: 5px"
              class="filters">

        <el-checkbox v-model="filters.onlyPublic">Only Public</el-checkbox>
        <label>Type</label>
        <s-remote-select
            queryProp="q"
            classModel="puptypes"
            v-model="filters.type"
            labelProp="title"
            valueProp="id"></s-remote-select>
        <label>Resort</label>
        <s-remote-select
            queryProp="q"
            classModel="locations"
            v-model="filters.resort"
            labelProp="name"
            valueProp="id"></s-remote-select>
        <label>Connected to meeting point</label>
        <s-remote-select
            queryProp="q"
            classModel="pup"
            v-model="filters.meetingpoint"
            :extraQueryParams="{type:5}"
            labelProp="name"
            valueProp="id"></s-remote-select>
        <label>General Search</label>
        <el-input v-model="filters.sname"></el-input>
        <label>Extra Columns</label>
        <q-toggle
            v-model="extraCols.email"
            label="Email"/>
        <q-toggle
            v-model="extraCols.meetingpoint"
            label="MeetingPoint"/>
        <q-toggle
            v-model="extraCols.transferpoint"
            label="Transfer Pick Up"/>
        <q-toggle
            v-model="extraCols.synonims"
            label="Synonyms"/>
        <q-toggle
            v-model="extraCols.timeoffset"
            label="Order"/>
      </el-row>
    </el-card>
    <el-card slot="body">
      <s-table
          ref="pups"
          @cell-change="handlePup"
          :colDefinitions="colPPsDefinitions"
          modx-processor="pup/getlist"
          :r-query="filters"
          @cell-clicked="removePup"></s-table>
    </el-card>
    <el-dialog
        append-to-body
        title="Import meeting points and pickup times for services"
        :visible.sync="importDialog">
      <el-form
          ref="form"
          label-width="150px"
          v-if="importDialog">

        <el-row
            :gutter="20"
            id="uploader">
          <div>
            <el-upload

                class="upload-demo"
                drag
                :data="uploadParams"

                action="/assets/components/travel/connector.php"


                :on-success="alertSuccess">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                drop file here <em>or click to select</em>
              </div>
              <!-- <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div> -->
            </el-upload>

          </div>
        </el-row>
        <!--        <el-row>-->
        <!--          <el-alert-->
        <!--              :title="progressMsg"-->
        <!--              type="success"-->
        <!--              :closable="false"></el-alert>-->
        <!--        </el-row>-->
      </el-form>
      <el-alert
          v-if="success"
          :title="'Imported successfully '+success+' for services by meeting points'"
          type="success"
          effect="dark"/>
      <el-card v-if="importProblems" v-for="(errors,erroCat) in importProblems" :key="erroCat">
        <div slot="header"><strong>{{ erroCat }}</strong></div>
        <el-row v-for="(error,keyTag) in errors" :key="keyTag">
          <el-col>
            <el-tag type="danger"><strong>{{ keyTag }}</strong></el-tag>
            {{ error[0] }}
          </el-col>
        </el-row>
      </el-card>
      <!--      <span-->
      <!--          slot="footer"-->
      <!--          class="dialog-footer">-->
      <!--        <el-button @click="importDialog=false">Done</el-button>-->
      <!--        &lt;!&ndash; <el-button type="primary" @click="importDialog = false">Confirm</el-button> &ndash;&gt;-->
      <!--      </span>-->
    </el-dialog>
  </sc-panel-navigator>

</template>

<script>
import * as api from "~/api/resource";

import {mapGetters, mapActions} from "vuex";

import ScPanelNavigator from "../../Layout/PanelNavigator";
import SRemoteSelect from "../../Form/SRemoteSelect";


export default {
  components: {SRemoteSelect, ScPanelNavigator},

  data() {
    return {
      uploadParams: {//
        HTTP_MODAUTH: window.Travel.auth,
        ctx: "web",
        do: 'update-meeting-points',
        action: "pup/import",
      },
      importProblems: null,
      success: 0,
      importDialog: false,
      search: null,
      extraCols: {meetingpoint: false, transferpoint: false, email: false, synonims: false, timeoffset: false},
      filters: {resort: null, type: null, sname: null}
    };
  },
  computed: {

    colPPsDefinitions() {
      var rw = "100px";
      if (window.innerWidth < 500) rw = "180px";
      if (window.innerWidth < 700) rw = "280px";
      if (window.innerWidth < 1000) rw = "380px";
      return [
        {

          prop: "type",
          width: rw,
          label: "Type",

          editable: true,

          editorcomponent: {
            is: "s-remote-select",
            bestFit: false,

            classModel: "puptypes",
            labelProp: "title",
            valueProp: "id",

          },
          onChange(ev, row) {
            _log_("is..onChange..", ev, row);
            if (ev.obj) {
              row.typename = ev.obj.title
            }

          },
          formatter: function (val, cols, row) {
            return val ? row.typename : null
          },
        },
        {

          prop: "location",
          minWidth: "250px",
          label: "Location",

          editable: true,

          editorcomponent: {
            is: "s-remote-select",
            limit: 200,
            queryProp: "q",
            classModel: "locations",
            labelProp: "name",
            valueProp: "id",

          },
          onChange(ev, row) {
            _log_("is..onChange..", ev, row);
            if (ev.obj) {
              row.loc_name = ev.obj.name
            }
            // if (row.meetingpoint) {
            //   const data = await api.getObject('Pup', row.meetingpoint)
            //   if (data) row.mpname = data.names
            // }
          },
          formatter: function (val, cols, row) {
            return val ? row.loc_name : '!!!'
          },
        },
        {prop: "name", width: "", label: "Name", minWidth: "150px", editable: true,},
        {prop: "email", width: "", label: "Email", editable: true,},
        {

          prop: "meetingpoint",
          minWidth: "250px",
          label: "MeetingPoint",

          editable: true,

          editorcomponent: {
            is: "s-remote-select",
            limit: 200,
            queryProp: "q",
            classModel: "pup",
            labelProp: "name",
            valueProp: "id",
            extraQueryParams: {_type: 'MEETINGPOINT'},
            captionField: "typename",
            prefixField: "loc_name",
          },
          onChange(ev, row) {
            _log_("is..onChange..", ev, row);
            if (ev.obj) {
              row.excrs_meet_name = ev.obj.name
            }
            // if (row.meetingpoint) {
            //   const data = await api.getObject('Pup', row.meetingpoint)
            //   if (data) row.mpname = data.names
            // }
          },
          formatter: function (val, cols, row) {
            return val ? row.excrs_meet_name : '-'
          },
        },
        {

          prop: "transferpoint",
          minWidth: "250px",
          label: "Transfer Pick Up",

          editable: true,

          editorcomponent: {
            is: "s-remote-select",
            limit: 200,
            queryProp: "q",
            classModel: "pup",
            labelProp: "name",
            valueProp: "id",
            // extraQueryParams: {_type: 'MEETINGPOINT'},
            captionField: "typename",
            prefixField: "loc_name",
          },
          onChange(ev, row) {
            _log_("is..onChange..", ev, row);
            if (ev.obj) {
              row.trans_meet_name = ev.obj.name
            }
            // if (row.meetingpoint) {
            //   const data = await api.getObject('Pup', row.meetingpoint)
            //   if (data) row.mpname = data.names
            // }
          },
          formatter: function (val, cols, row) {
            return val ? row.trans_meet_name : '-'
          },
        },
        {
          prop: "synonims",
          minWidth: "250px",
          label: "Synonyms",
          editable: true,
          forwardEditOnChange: false,
          editorcomponent: {
            is: "SCSimpleStrArray",

            type: "textarea",
            autosize: true
          },
          formatter(val, colDefs, row) {
            return val ? val.replaceAll('|', '<i class="material-icons">filter_list</i>') : null
            // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';      <i class="material-icons">filter_list</i>
          }
        },
        {
          prop: "isPublic",
          minWidth: "50px",
          width: "50px",
          label: "Public",
          editable: true,
          forwardEditOnChange: false,
          editorcomponent: {
            is: "el-checkbox",

          },
          formatter: function (val, cols, row) {
            return val ? '<i class="material-icons" >done</i >' : ''
          },
        },
        {prop: "timeoffset", width: "", label: "Order", editable: true,},
        // {
        //   prop: "delete",
        //   width: "60px",
        //   label: "X",
        //   fixed: "right",
        //   sortable: false,
        //   viewcomponent: {
        //     is: "el-button",
        //     icon: "el-icon-delete",
        //     type: "danger",
        //     circle: true
        //   },
        //   formatter(val, colDefs, row) {
        //     return "-";
        //     // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';      <i class="material-icons">filter_list</i>
        //   }
        // },
        {
          prop: "delete",
          width: "60px",
          label: "X",
          fixed: "right",
          sortable: false,

          viewcomponent: {
            is: "el-button",
            icon: "el-icon-delete",
            type: "danger",
            circle: true
          },
          formatter(val, colDefs, row) {
            return "-";
            // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';
          }
        }
      ].filter(col => this.extraCols[col.prop] !== false);
    },
    navpath() {
      _log_("is..R..", this.$route);
      return this.$route.path == "/excursion" ? "/bookings" : this.$route.path;
    },
  },
  methods: {
    alertSuccess(e) {
      _log_("hell.RRs..", e);
      if (e.object?.errors)
        this.importProblems = e.object.errors
      if (e.object?.success)
        this.success = e.object.success.length
    },
    async removePup(e) {
      var vm = this;
      _log_("hell.RRs..", e);
      // _log_("trans.ss.go ii..", e);
      if (e.column.property == "delete") {
        if (!e.row.id) return;
        this.$confirm(
            "This will permanently delete the record. Continue?",
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning"
            }
        )
            .then(() => {

              vm.$refs.pups.removeRow({idx: e.row.idx}, true)
              api.removeObject("pup", {id: e.row.id});

            })
        // .catch(() => {
        // });
      }
    },
    async handlePup(e) {
      //process before edit

      const data = await api.updateProcessor("pup/update", e.row);
      this.$refs.pups.updateRow({idx: e.row.idx}, {id: data.id})
      // this.$refs.bookingList.reloadRow(e.row.id);
    },
  },
  watch: {
    // "$route.params.tripid": {
    //   async handler(val, oldval) {
    //   },
    //   immediate: true
    // }
  },
  async mounted() {
    _log_("is..R..", this.$route);
  },
};
</script>
<style>
div.filters label {
  width: 100%;
}
</style>
